import { AddOnType } from '../../../../doppler-types';
import { InjectAppServices } from '../../../../services/pure-di';
import { ConversationPlan } from './ConversationPlan';
import { OnSitePlan } from './OnSitePlan';
import { PushNotificationPlan } from './PushNotificationPlan';
import { LandingPagesPlan } from './LandingPagesPlan';
import { FormattedNumber } from 'react-intl';
import { EcoAIPlan } from './EcoAIPlan';

export const formattedNumber = (value, decimals) => {
  const numberFormatOptions = {
    style: 'decimal',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  };

  return <FormattedNumber value={value} {...numberFormatOptions} />;
};

export const AddOnPlan = InjectAppServices(
  ({ addOnType, addOnPlan, addOnBuyUrl, isFreeAccount, addOnPromotions }) => {
    return (
      <>
        {addOnType === AddOnType.Conversations && (
          <ConversationPlan
            buyUrl={addOnBuyUrl}
            conversationPlan={addOnPlan}
            isFreeAccount={isFreeAccount}
            addOnPromotions={addOnPromotions}
          ></ConversationPlan>
        )}
        {addOnType === AddOnType.OnSite && (
          <OnSitePlan
            buyUrl={addOnBuyUrl}
            onSitePlan={addOnPlan}
            isFreeAccount={isFreeAccount}
            addOnPromotions={addOnPromotions}
          ></OnSitePlan>
        )}
        {addOnType === AddOnType.PushNotifications && (
          <PushNotificationPlan
            buyUrl={addOnBuyUrl}
            pushNotificationPlan={addOnPlan}
            isFreeAccount={isFreeAccount}
            addOnPromotions={addOnPromotions}
          ></PushNotificationPlan>
        )}
        {addOnType === AddOnType.Landings && (
          <LandingPagesPlan
            buyUrl={addOnBuyUrl}
            landingPagesPlan={addOnPlan}
            addOnPromotions={addOnPromotions}
          ></LandingPagesPlan>
        )}
        {addOnType === AddOnType.EcoAI && (
          <EcoAIPlan
            buyUrl={addOnBuyUrl}
            ecoAiPlan={addOnPlan}
            isFreeAccount={isFreeAccount}
            addOnPromotions={addOnPromotions}
          ></EcoAIPlan>
        )}
      </>
    );
  },
);
